import { Floor } from 'src/api/types';

import { FloorsState } from './types';

export const emptyFloorsByBuilding = new Map<number, Set<number>>();

export const emptyFloorsById = new Map<number, Floor>();

export const emptyCurrentRequests = new Set<number>();

export const initialState: FloorsState = {
  loading: false,
  currentRequests: emptyCurrentRequests,
  floorsByBuilding: emptyFloorsByBuilding,
  floorsById: emptyFloorsById,
};
